import noticeService from "../../services/notice"
import messageStore from "../store/index"
import { action, runInAction } from "mobx"
import { reportUserBehaviorCgi } from "@/api/operator/cgi/smb/common"
import { getNoticeList } from "../../api"
import _ from "lodash"

class AnnouncementService {
  // 获取消息列表
  @action
  getNoticeList = (flag) => {
    if (!flag) {
      messageStore.messageAnnouncementStore.announcementData = {
        loadingShow: true,
      }
    }

    return getNoticeList({
      is_home_page: 0,
      data: messageStore.messageAnnouncementStore.config,
    }).then(
      (res) => {
        let result
        if (res.code === 0) {
          result = {
            ...res.data,
            loadingShow: false,
          }
        } else {
          result = {
            loadingShow: false,
          }
        }
        runInAction(() => {
          messageStore.messageAnnouncementStore.announcementData = result
        })
      },
      (err) => {
        runInAction(() => {
          messageStore.messageAnnouncementStore.announcementData = {
            loadingShow: false,
          }
        })
      }
    )
  }

  // 为数据源标记消息已读
  @action
  noticeReadedMark(id) {
    messageStore.messageAnnouncementStore.announcementData.list = (messageStore.messageAnnouncementStore.announcementData.list || []).map((item) => {
      if (item.id === id) {
        item.is_read = 1
      }
      return item
    })
  }

  @action
  handlePagesChange = (value) => {
    messageStore.messageAnnouncementStore.config = {
      ...messageStore.messageAnnouncementStore.config,
      page: value,
    }
    this.getNoticeList()
  }

  // 改变消息状态
  @action
  handleOpen = (msgId, is_read, name) => {
    reportUserBehaviorCgi({
      data: {
        behavior: "点击公告列表",
        page1: "公告中心",
        relation_id: msgId,
        relation_type: "notice",
        relation_name: name,
      },
    })
    return noticeService.handleNoticeReaded(msgId, "公告中心", name)
  }
}

export default new AnnouncementService()
